import React from 'react';
import FloatingBackground from '../Common/FloatingBackground/FloatingBackground';
import AboutUsHero from './components/AboutUsHero';
import AboutUsMission from './components/AboutUsMission';
import AboutUsStory from './components/AboutUsStory';
import AboutUsTestimonials from './components/AboutUsTestimonials';
import AboutUsTechnology from './components/AboutUsTechnology';
import AboutUsCTA from './components/AboutUsCTA';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  // Component flags for conditional rendering
  const componentFlags = {
    hero: true,
    mission: true,
    story: true,
    testimonials: false, // Disabled - no testimonials yet
    technology: true,
    cta: true,
  };

  return (
    <div className="about-page">
      <FloatingBackground />

      <div className="about-container">
        {componentFlags.hero && <AboutUsHero />}
        {componentFlags.mission && <AboutUsMission />}
        {componentFlags.story && <AboutUsStory />}
        {componentFlags.testimonials && <AboutUsTestimonials />}
        {componentFlags.technology && <AboutUsTechnology />}
        {componentFlags.cta && <AboutUsCTA />}
      </div>
    </div>
  );
};

export default AboutUs;
